import { clear, createStore, get, set, del, update, UseStore } from 'idb-keyval'
import { localStorageKeys } from '@/common/storage-keys'
import { localStorage } from '@/utils/storage'

const INDEXED_DB_VER = 1
const DB_NAME = 'ONTAP_IDB'

class IDb {
  private _store: UseStore

  constructor () {
    const localVer = localStorage.get(localStorageKeys.IDB_VERSION, INDEXED_DB_VER)

    if (localVer !== INDEXED_DB_VER) {
      clear()
    }
    localStorage.set(localStorageKeys.IDB_VERSION, INDEXED_DB_VER)
    this._store = createStore(DB_NAME, DB_NAME)
  }

  /**
   * @description Lấy dữ liệu cache trong IndexedDB
   * @param key
   * @param fallbackVal Dữ liệu trả về nếu không tồn tại trong DB
   * @returns
   * @author PHNam
   */
  public async get (key: string, fallbackVal?: any) {
    return (await get(key, this._store)) || fallbackVal
  }

  /**
   * @description Lưu dữ cache vào IndexedDB
   * @param key
   * @param value
   * @returns
   * @author PHNam
   */
  public async set (key: string, value: any) {
    return await set(key, value, this._store)
  }

  /**
   * @description Cập nhật dữ liệu cache trong IndexedDB
   * @param key
   * @param value
   * @returns
   * @author PHNam
   */
  public async update (key: string, value: any) {
    return await update(key, () => value, this._store)
  }

  /**
   * @description Xóa dữ liệu cache trong IndexedDB
   * @param key
   * @returns
   * @author PHNam
   */
  public async delete (key: string) {
    return await del(key, this._store)
  }

  /**
   * @description Xóa dữ liệu cache trong IndexDB
   * @returns
   * @author PHNam
   */
  public async clear () {
    return await clear(this._store)
  }
}

export default new IDb()
